import React from 'react';
import { Button } from '@awarego-ui/components';

function Testcomp() {
    return (
        <div>
            <Button otherText="hello">TEST</Button>
        </div>
    );
}

export default Testcomp;
